import { spotlight } from "@mantine/spotlight";

const GlobalSearchNavbar = () => {
  return (
    <>
      <div className="d-none d-md-block">
        <div
          className="cursor-pointer d-flex align-items-center mt-1 ml-2 text-medium"
          onClick={spotlight.open}
          style={{ letterSpacing: 0.25 }}
        >
          <i className="mdi mdi-magnify ml-1 mr-3" style={{ fontSize: 22 }} />
          Search Cloud...{" "}
        </div>
      </div>
      <div
        className="d-xs-block d-md-none"
        style={{ marginLeft: 40, padding: 0 }}
      >
        <span
          className="avatar avatar-sm rounded text-capitalize text-center link-hovered bg-white text-secondary cursor-pointer"
          onClick={spotlight.open}
        >
          <i
            className="mdi mdi-magnify"
            style={{
              fontSize: "24px",
              position: "relative",
              top: 1,
            }}
          />
        </span>
      </div>
    </>
  );
};

export default GlobalSearchNavbar;
